<template>
  <div>
    <v-row class="mb-1">
      <v-col cols="12" md="12" xs="12" class="text-center">
        <v-btn
          fab
          small
          color="grey darken-4"
          title="prev"
          class="white--text mr-2"
          @click="prev"
        >
          <v-icon> mdi-chevron-left </v-icon>
        </v-btn>
        <v-btn
          fab
          small
          color="grey darken-4"
          title="next"
          class="white--text"
          @click="next"
        >
          <v-icon> mdi-chevron-right </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <canvas class="shadow mycanvas" id="canvas-element"></canvas>
  </div>
</template>
<script>
// import * as pdfjsLib from 'pdfjs-dist/build/pdf'
// "pdfjs-dist": "^2.5.207",
// import * as pdfjsLib from 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/build/pdf.min.js'

export default {
  name: 'pdfCanvas',
  components: {},
  props: ['url'],
  data () {
    return {
      totalPages: 1,
      pdfRef: null,
      currentPage: 1
    }
  },
  created: async function () {
    const script = document.createElement('script')
    script.src =
      'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/build/pdf.min.js'
    script.id = 'pdfjs'
    document.body.appendChild(script)
    let that = this
    script.onload = () => {
      that.renderPdf(that.url)
    }
  },

  methods: {
    renderPdf (url) {
      this.loadingComponent = this.$buefy.loading.open()
      let that = this
      let pdfjsLib = window['pdfjs-dist/build/pdf']
      // console.log(pdfjsLib, 'pdfjsLib')
      // Renders given PDF to Canvas Element
      // console.log('S3 Url', url)
      pdfjsLib.GlobalWorkerOptions.workerSrc =
        'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/build/pdf.worker.min.js'
      // Asynchronous download of PDF
      let loadingTask = pdfjsLib.getDocument(url)
      loadingTask.promise.then(
        function (pdf) {
          let pageCount = pdf._pdfInfo.numPages
          that.totalPages = pageCount
          // console.log('PDF loaded')
          // console.log('No Of Pages: ' + pageCount)
          that.pdfRef = pdf
          that.renderPdfPage()
        },
        function (reason) {
          console.error(reason)
        }
      )
      this.loadingComponent.close()
    },
    prev () {
      if (this.currentPage - 1 >= 1) {
        this.renderPdfPage(this.currentPage - 1)
      }
    },
    next () {
      if (this.currentPage + 1 <= this.totalPages) {
        this.renderPdfPage(this.currentPage + 1)
      }
    },
    renderPdfPage (pageNum = 1) {
      this.currentPage = pageNum
      this.pdfRef.getPage(pageNum).then((page) => {
        // console.log('Page Loaded')
        // Scale PDF View Variable
        let scale = 1.5
        let viewport = page.getViewport({ scale: scale })
        // Prepare canvas using PDF page dimensions
        let canvas = document.getElementById('canvas-element')
        let context = canvas.getContext('2d')
        canvas.height = viewport.height
        canvas.width = viewport.width
        // Render PDF page into canvas context
        let renderContext = {
          canvasContext: context,
          viewport: viewport
        }
        let renderTask = page.render(renderContext)
        renderTask.promise.then(function () {
          // console.log('Page rendered')
        })
      })
    }
  }
}
</script>
<style scoped>
#canvas-element {
  width: 100%;
}
</style>
